import * as React from 'react';
import { connect, ConnectedComponent } from 'react-redux';
import { Dispatch } from 'redux';
import * as I from '../../../../../interfaces/merchants/products/purchases';
import { init } from '../../../../../redux/actions/merchants/products/purchases';
import PerchaseAvailable from '../../../../hoc/PurchaseAvailable';
import ProductDetail from './detail';
import SchemeTypeSubscription from './SchemeTypeSubscription';
import SchemeTypeTicketBook from './SchemeTypeTicketBook';

interface ElementProps {
  publicId: string;
  productId: string;
}

interface StateProps {
  purchases: I.State;
}

interface DispatchProps {
  dispatch: Dispatch;
}

interface State {
  isStart: boolean;
}

// 'children?: React.ReactNode' must be defined manually (for bug?)
// see https://github.com/DefinitelyTyped/DefinitelyTyped/issues/42537#issuecomment-593519008
type Props = ElementProps &
  StateProps &
  DispatchProps & { children?: React.ReactNode };

const CONTROLLER_COMPONENTS: {
  // tslint:disable-next-line:no-any
  [schemeType in I.SchemeType]: ConnectedComponent<any, any>;
} = {
  [I.SchemeType.Subscription]: SchemeTypeSubscription,
  [I.SchemeType.TicketBook]: SchemeTypeTicketBook,
};

class MerchantProductPurchaseModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { isStart: false };
    this.handleStart = this.handleStart.bind(this);
  }

  public componentDidMount() {
    const { dispatch, publicId, productId } = this.props;
    init({ publicId, productId })(dispatch);
  }

  private handleStart() {
    this.setState({ isStart: true });
  }

  public render() {
    const {
      productId,
      purchases: { merchantProduct, settings, step },
    } = this.props;

    if (
      !merchantProduct ||
      (merchantProduct && merchantProduct.publicId !== productId)
    ) {
      return null;
    }

    // product detail
    if (!this.state.isStart) {
      const imageUrl =
        merchantProduct.image &&
        merchantProduct.image.medium &&
        merchantProduct.image.medium.url;
      return (
        <ProductDetail
          imageUrl={imageUrl}
          onClick={this.handleStart}
          {...merchantProduct}
        />
      );
    }

    if (!settings || step === undefined || step === null) {
      return null;
    }

    const ControllerComponent = CONTROLLER_COMPONENTS[settings.schemeType];
    if (!ControllerComponent) {
      return null;
    }

    // purchase flow
    return <ControllerComponent />;
  }
}

const mapStateProps = ({
  merchantsProductsPurchases,
}: {
  merchantsProductsPurchases: I.State;
}): StateProps => ({
  purchases: merchantsProductsPurchases,
});

export default PerchaseAvailable<ElementProps>(
  connect<StateProps, {}, ElementProps>(mapStateProps)(
    MerchantProductPurchaseModal,
  ),
);
